import _ from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classes from "./AssessmentToolPreviewModalV2.scss";
import withLoader from "UIComponents/GqlWithLoader";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import { graphql, compose } from "lib/apolloClient";
import { getAssessmentToolNodeDetailsQuery } from "modules/CommonQuery";
import { getAssessmentToolNodeDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import RubricTable from "Rubric/components/RubricTable";
import ChecklistTable from "Checklist/components/ChecklistTable";
import SinglePointRubricTable from "SinglePointRubric/components/SinglePointRubricTable";
import MYPObjectiveRubric from "UnitPlans/components/IBcomponents/AssessmentTool/MYPObjectiveRubric";
import { getMYPObjectiveRubricOptions } from "modules/Services";
import CriteriaRubricAssessmentWrapper from "UnitPlans/components/IBcomponents/CriteriaRubricAssessmentWrapper";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import classNames from "classnames";
import { SKIP_ASSESSMENT_TOOL_NODE_TOOLS } from "ClassRoom/modules/utils";
import EvaluationStatus from "AssessmentEvaluation/components/EvaluationStatus";
import {
  SCORE_BASED_RUBRIC,
  STANDARD_BASED_RUBRIC,
  GRADE_SCALE_TOOL,
} from "Constants/stringConstants";
import StandardRubric from "AppComponents/StandardRubric";
import AssessmentGradeScaleTool from "AppComponents/AssessmentGradeScaleTool";

const getModalContent = props => {
  const {
    title,
    onClickClose,
    t,
    showEvaluateStatus,
    type,
    isEvaluatedByStudent,
    isTeacherEvaluationEnabled,
    userType,
  } = props;

  const renderAssessmentTool = () => {
    const {
      assessmentTool,
      mode,
      toolResponses,
      unitPlanFields,
      assessmentFields,
      field_list,
      parentId,
      parentType,
      studentId,
      isEvaluated,
      ibPYPElementRatings,
      showRatingContainerInViewMode,
      commentMessage,
      scoreValue,
      maxScore,
    } = props;

    switch (type) {
      case "RUBRIC":
        return (
          <RubricTable
            mode={mode}
            rubric={assessmentTool}
            toolEvaluationResponses={toolResponses}
            isEvaluatedByStudent={isEvaluatedByStudent}
          />
        );
      case "CHECKLIST":
        return (
          <ChecklistTable
            mode={mode}
            checklist={assessmentTool}
            toolEvaluationResponses={toolResponses}
            isEvaluatedByStudent={isEvaluatedByStudent}
          />
        );
      case "SINGLE_POINT_RUBRIC":
        return (
          <SinglePointRubricTable
            mode={mode}
            rubric={assessmentTool}
            isEvaluation={isTeacherEvaluationEnabled}
            toolEvaluationResponses={toolResponses}
            isEvaluatedByStudent={isEvaluatedByStudent}
          />
        );
      case "MYP_OBJECTIVE_RUBRIC":
      case "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC":
        return (
          <MYPObjectiveRubric
            assessmentTool={assessmentTool}
            mode={mode}
            parentId={parentId}
            parentType={parentType}
            studentId={studentId}
            isEvaluated={isEvaluated}
            options={getMYPObjectiveRubricOptions({
              unitPlanFields,
              assessmentFields,
              field_list,
              measureAssessingValue: type,
            })}
            toolEvaluationResponses={toolResponses}
            isEvaluatedByStudent={isEvaluatedByStudent}
            ibPYPElementRatings={ibPYPElementRatings}
            showRatingContainerInViewMode={showRatingContainerInViewMode}
          />
        );
      case "DP_ASSESSMENT_RUBRIC":
        return (
          <CriteriaRubricAssessmentWrapper
            criteria={assessmentTool?.criteria}
            ibPYPElementRatings={ibPYPElementRatings}
            mode={mode}
            isEvaluated={isEvaluated}
            studenId={studentId}
            parentId={parentId}
            parentType={parentType}
            assessmentTool={assessmentTool}
          />
        );
      case "COMMENT":
        return (
          commentMessage && (
            <div className={classes.commentText}>{commentMessage}</div>
          )
        );
      case "SCORE":
        return (
          <div className="text-body-1">
            {scoreValue} {t("common:out_of_with_label", { label: maxScore })}
          </div>
        );
      case SCORE_BASED_RUBRIC:
      case STANDARD_BASED_RUBRIC: {
        return (
          <StandardRubric
            mode={mode}
            rubric={assessmentTool}
            toolEvaluationResponses={toolResponses}
            isEvaluatedByStudent={isEvaluatedByStudent}
            type={type}
          />
        );
      }
      case GRADE_SCALE_TOOL: {
        return (
          <AssessmentGradeScaleTool
            mode={mode}
            rubric={assessmentTool}
            toolEvaluationResponses={toolResponses}
            isEvaluatedByStudent={isEvaluatedByStudent}
          />
        );
      }
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <div className={classes.modalHeader}>
        <span>{title ? title : t("common:no_title")}</span>
        <span className={classes.actionButtons} style={{ marginRight: "16px" }}>
          <IconButton
            icon={<CloseOutlined />}
            variant="plain"
            onClick={onClickClose}
          />
        </span>
      </div>
      <div className={classes.modalBody}>
        {showEvaluateStatus ? (
          <EvaluationStatus
            toolType={type}
            isEvaluatedByStudent={isEvaluatedByStudent}
            isEvaluatedByTeacher={isTeacherEvaluationEnabled}
            userType={userType}
          />
        ) : null}
        <div className={classes.innerWrapper}>{renderAssessmentTool()}</div>
      </div>
    </React.Fragment>
  );
};

const AssessmentToolModalWithLoader = withLoader(getModalContent);
class AssessmentToolPreviewModalV2 extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { onClickClose, type } = this.props;

    const modalContentClass = classNames({
      [classes.modalContent]: true,
      [classes.modalContentComment]: type === "COMMENT",
      [classes.modalContentScore]: type === "SCORE",
    });

    return (
      <UIModal
        isOpen={true}
        modalContent={modalContentClass}
        onRequestClose={onClickClose}
      >
        <AssessmentToolModalWithLoader {...this.props} />
      </UIModal>
    );
  }
}

AssessmentToolPreviewModalV2.defaultProps = {
  isEvaluated: true,
  showEvaluateStatus: false,
};

const mapActionCreators = {
  setToastMsg,
};

const mapStateToProps = (state, ownProps) => {
  const userType = _.get(state, "login.userInfo.user_type", "");

  return {
    isData: true,
    isLoading: false,
    userType,
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getAssessmentToolNodeDetailsQuery, {
    name: "getAssessmentToolNodeDetails",
    options: ({ id, entityType }) => ({
      fetchPolicy: "cache-and-network",
      variables: { id, type: entityType },
    }),
    skip: ({ entityType }) =>
      _.includes(SKIP_ASSESSMENT_TOOL_NODE_TOOLS, entityType),
    props({
      getAssessmentToolNodeDetails,
      ownProps: { isData, isLoading, id, entityType },
    }) {
      const queryData = getAssessmentToolNodeDetailsFromCache({
        id,
        type: entityType,
      });
      const networkStatus = _.get(
        getAssessmentToolNodeDetails,
        "networkStatus"
      );
      return {
        assessmentTool: queryData,
        isData: !_.isEmpty(queryData) && isData,
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  })
)(AssessmentToolPreviewModalV2);
